import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "事件档案", to: "/events" },
  { label: "吃瓜指南", to: "/faq" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen
          ? "bg-background-50/92 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="h-16 md:h-20 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 cursor-pointer shrink-0">
            <span className="w-9 h-9 md:w-10 md:h-10 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading font-bold text-sm md:text-base">
              131
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg md:text-xl font-bold text-foreground-950 whitespace-nowrap">吃瓜</span>
              <span className="text-[10px] md:text-[11px] tracking-widest text-foreground-500 whitespace-nowrap">EVIDENCE ARCHIVE</span>
            </span>
          </Link>

          <nav aria-label="主导航" className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap ${
                    isActive
                      ? "text-primary-500 bg-primary-100/60"
                      : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2 md:gap-3">
            <Link
              to="/events"
              aria-label="搜索事件档案"
              className="hidden sm:flex w-9 h-9 md:w-10 md:h-10 items-center justify-center rounded-md border border-background-200 text-foreground-600 hover:text-primary-500 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <i className="ri-search-line text-lg" />
            </Link>
            <Link
              to="/about#submit"
              className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-send-plane-line" />
              提交线索
            </Link>
            <button
              type="button"
              aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((prev) => !prev)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-200 text-foreground-800 cursor-pointer"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200/70 bg-background-50/98 backdrop-blur-md">
          <nav aria-label="移动端导航" className="max-w-[1280px] mx-auto px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-md text-sm cursor-pointer ${
                    isActive ? "text-primary-500 bg-primary-100/60" : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/about#submit"
              className="mt-2 inline-flex items-center justify-center gap-1.5 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium cursor-pointer whitespace-nowrap"
            >
              <i className="ri-send-plane-line" />
              提交线索
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}